import { Component } from "@angular/core";

/**
 * Generated class for the StatusIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "status-icon",
  template:
    "<div [ngClass]=\"{'online':onlineStatus, 'offline':!onlineStatus}\" ></div>",
})
export class StatusIconComponent {
  onlineStatus: boolean;

  constructor() {
    this.onlineStatus = false;
    this.createStatusPoller();
  }

  createStatusPoller() {
    this.updateStatus();

    setInterval(() => {
      this.updateStatus();
    }, 10000);
  }

  updateStatus() {
    // console.log( "CHECKING STATUS" );
    this.onlineStatus = window.navigator.onLine;
    // console.log( "Updated onlineStatus: ", this.onlineStatus );
  }
}



// WEBPACK FOOTER //
// ./src/providers/online-status/status-icon/status-icon.ts